import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=5b1f2d64"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"
import style0 from "./Card.vue?vue&type=style&index=0&id=5b1f2d64&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1f2d64')) {
      api.createRecord('5b1f2d64', component.options)
    } else {
      api.reload('5b1f2d64', component.options)
    }
    module.hot.accept("./Card.vue?vue&type=template&id=5b1f2d64", function () {
      api.rerender('5b1f2d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Attractions/Card.vue"
export default component.exports